import type { FC } from 'react';
import React from 'react';
import { Button, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { NestedFlowNodeType } from './types';
import type { InputVar, NodePanelProps } from '../../types';
import useConfig from './use-config';
import Field from '../_base/components/field';
import InputVarTypeIcon from '../_base/components/input-var-type-icon';
import { InputVarType } from '../../types';
import BfSelector from './components/bf-selector';

const Panel: FC<NodePanelProps<NestedFlowNodeType>> = ({ id, data }) => {
  const {
    readOnly,
    inputs,
    handleBfInfoChange,
    handleDescChange
  } = useConfig(id, data);

  const { detail } = inputs;
  return (
    <div className="mt-2">
      <div className="space-y-4 px-4 pb-2">
        <Field title="关联流程">
          <BfSelector
            value={detail.nestedFlowInfo}
            onChange={handleBfInfoChange}
          />
        </Field>
        <Field title="描述">
                  <div
                    className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
                  >
                    <div className="flex w-0 grow items-center space-x-1 bg-components-input-bg-normal rounded-lg">
                      <Input.TextArea
                        className="w-full"
                        value={detail.desc}
                        onChange={(e) =>
                          handleDescChange(e.target.value)
                        }
                        maxLength={120}
                        bordered={false}
                        autoSize
                        showCount
                        allowClear
                      />
                    </div>
                    <div className="ml-2 flex shrink-0 items-center">
                      <InputVarTypeIcon
                        type={InputVarType.textInput}
                        className="h-3.5 w-3.5 text-gray-500"
                      />
                    </div>
                  </div>
                </Field>
      </div>
    </div>
  );
};

export default React.memo(Panel);
